import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionService } from '../../services/subscription.service';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from '../../../../services/company.service';
import { NtCompany } from '../../models/nt-company';
import { orgServiceModel } from '../../models';

@Component({
  selector: 'app-subscription-free-trial-bar',
  templateUrl: './subscription-free-trial-bar.component.html',
  styleUrls: ['./subscription-free-trial-bar.component.scss']
})
export class SubscriptionFreeTrialBarComponent implements OnInit, OnDestroy {
    freeTrialActive = false;
    paymentMethodRequired = false;
    billingStartDate: Date;
    orgId = '';
    subId = 0;

    sub = new Subject();
    
    constructor(private comp: CompanyService,
            private subSvc: SubscriptionService
    ) { }

    ngOnInit(): void {
        this.comp.SelectedCompany.pipe(takeUntil(this.sub))
            .subscribe(c => {
                if(this.comp){
                    this.updateView(c);
                }
            });
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

    get paymentUrl() {
        return ['/account/organisation', this.orgId, 'subscription', this.subId, 'free-trial']; //`/manage/free-trial/${this.orgId}/${this.subId}`;
    }

    async updateView(c: NtCompany) {
        if (c) {
            if (c.subscribedService) {
                this.setProperties(c.subscribedService, c.subscribedService.billingOrganisationId);
            } else {
                const u = await this.subSvc.getUserOrganisation(c.billingOrganisationId)
                if(u){
                    const s = u.services.find(x => x.id === c.subscribedServiceId);
                    this.setProperties(s, s.billingOrganisationId);
                }
            }
        } else {
            this.freeTrialActive = false;
        }
      }
    
    setProperties(s: orgServiceModel, id: string) {
        this.freeTrialActive = s.freeTrialActive;
        this.paymentMethodRequired = !s.validPaymentMethod;
        this.orgId = id;
        this.subId = s.id;
        this.billingStartDate = s.billingStartDate;
    }

}
